import { Injectable } from '@angular/core';

import { DefaultRedirectStrategy } from './default-redirect-strategy';
import { RedirectCommand } from './redirect-command';
import { RedirectStrategyContext } from './redirect-strategy';
import { RedirectStrategyFactory } from './redirect-strategy-factory';

@Injectable({
    providedIn: 'root'
})
export class RedirectCommandProvider {
    constructor(
        private readonly redirectStrategyFactory: RedirectStrategyFactory,
        private readonly defaultRedirectStrategy: DefaultRedirectStrategy
    ) {}

    execute(scenario: string, context?: RedirectStrategyContext): Promise<RedirectCommand> {
        const strategyInstance = this.redirectStrategyFactory.create(scenario);
        if (!strategyInstance) {
            return this.defaultRedirectStrategy.execute();
        }
        return strategyInstance.execute(context);
    }
}
